'use client';

import { useState, useEffect } from 'react';

// Einfacher Hook, um den Usernamen überall zu nutzen
export function useUser() {
  const [username, setUsername] = useState('Commander');

  useEffect(() => {
    const saved = localStorage.getItem('lan-username');
    if (saved) setUsername(saved);
  }, []);

  const updateUsername = (name: string) => {
    setUsername(name);
    localStorage.setItem('lan-username', name);
  };

  return { username, updateUsername };
}
